module.exports = __webpack_public_path__ + "static/img/10028.b7fff03e.png";